export function normalizeUsername(text) {
  return text.toLowerCase().replace(/[\W_]+/g, "-");
}

export function normalizeHashtag(text) {
  return text.toLowerCase().replace(/[\W_]+/g, "-");
}
